import {
  priceListHistorySchema,
  priceListUploadResponseSchema,
  type PriceListHistory,
  type PriceListUploadResponse,
} from '@console/types'
import { customerAppGet, customerAppPostForm } from '../customer-app.js'

export async function fetchTenantPriceLists(): Promise<PriceListHistory> {
  return customerAppGet('/api/v1/tenant-price-lists', priceListHistorySchema)
}

export interface UploadPriceListInput {
  file: File
  effectiveDate: string
  supersedesVersionId: string | null
  supplier: string
  currency: string
}

/**
 * `supersedesVersionId` is sent as `''` for "no current version" — the
 * server's own required-not-optional field, never simply absent
 * (`REQ-lighthouse-price-list-upload-and-versioning-shape`'s answer).
 */
export async function uploadTenantPriceList(
  input: UploadPriceListInput,
): Promise<PriceListUploadResponse> {
  const form = new FormData()
  form.set('file', input.file)
  form.set('effectiveDate', input.effectiveDate)
  form.set('supersedesVersionId', input.supersedesVersionId ?? '')
  form.set('supplier', input.supplier)
  form.set('currency', input.currency)
  return customerAppPostForm('/api/v1/tenant-price-lists', form, priceListUploadResponseSchema)
}
